import Image from 'next/image';
import style from './quote-section.module.scss'
import animations from "@components/shared/animation/animations.module.scss";
import SharedAnimation from "@components/shared/animation";

interface IQuoteSectionProps {
    section: {
        title: string;
        quoteSrc: string;
        comment: string;
        authorName: string;
        authorAvatar: string;
        authorSpecialist: string;
    }
    isDifferentColor?: boolean;
}

const QuoteSection = ({section, isDifferentColor}: IQuoteSectionProps) => {
    return (
        <>
            <SharedAnimation render={(ref) => (
                <div ref={ref}
                     className={`${isDifferentColor ? style.containerDifferent : style.container} ${animations.scroll__animation}`}>
                    <section className={`${style.section}`}>
                        <h2 className={style.quote__title}>
                            {section.title}
                        </h2>
                        <div className={style.quote__wrapper}>
                            <div>
                                <Image alt={'quote'} width="48" height="42"
                                       src={section.quoteSrc}/>
                            </div>

                            <div className={style.quote__text}>
                                {section.comment}
                            </div>

                            <div className={`${style.quote}`}>
                                <div className={`${style.quote__author__avatar}`}>
                                    <Image alt={section.authorName} layout={'fill'} sizes="200 100 50"
                                           src={section.authorAvatar}/>
                                </div>
                                <div className={`${style.quote__author}`}>
                                    {section.authorName && (
                                        <div className={`${style.quote__author__name}`}>
                                            {section.authorName}
                                        </div>
                                    )}
                                    {section.authorSpecialist && (
                                        <div className={`${style.quote__author__specialist}`}>
                                            {section.authorSpecialist}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            )}/>
        </>
    )
}

export default QuoteSection;